/* eslint react-hooks/refs: ["warn"] */
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import {
  filterValuesAreTheSame,
  normalizeFilterValuesFromCWH,
} from "../filter/filtervalue";
import { useRef } from "react";
import { FilterValue } from "../../types/filter";

export function useUserPreferenceStoreFilterValues(featureName: string) {
  const fallbackValueRef = useRef<FilterValue[]>([]);
  const [rawFilterValues, setFilterValues] = useUserPreference<FilterValue[]>(
    featureName,
    fallbackValueRef.current
  );

  const filterValues = normalizeFilterValuesFromCWH(rawFilterValues);

  const storeFilterValues = (values: FilterValue[]) => {
    if (!filterValuesAreTheSame(filterValues, values)) {
      setFilterValues(values);
    }
  };

  return { filterValues, setFilterValues: storeFilterValues };
}
